import moment from "moment";
import React, { ReactNode, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Constants } from "../Constants/ApiConstants";
import { arabicIndic, arabicIndicMap } from "../Constants/LangConstants";
import i18n from "../i18n";
import UnderConstruction from "../pages/UnderConstruction/UnderConstruction";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import classNames from "classnames";

interface TemplateProps {
  children?: ReactNode;
}

const Template: React.FC<TemplateProps> = () => {
  const { isSidebarCollapsed } = useSelector(
    (state: RootState) => state.sidebar,
  );
  moment.updateLocale("ar", {
    postformat: function (str: any) {
      return str.replace(arabicIndic, (d: any) => arabicIndicMap[d]);
    },
  });

  const [dir, setDir] = useState<"rtl" | "ltr">("ltr");

  useEffect(() => {
    const handleLangChange = (lng: string) => {
      setDir(lng.startsWith("ar") ? "rtl" : "ltr");
    };

    handleLangChange(i18n.language);

    i18n.on("languageChanged", handleLangChange);

    return () => {
      i18n.off("languageChanged", handleLangChange);
    };
  }, []);

  if (Constants.Under_Construction) return <UnderConstruction />;

  return (
    <div
      dir={dir}
      className="flex max-h-[100dvh] max-w-[100dvw] gap-2 overflow-hidden xl:pe-6 xl:ps-0 lg:gap-2 lg:pe-8"
    >
      <Sidebar />
      <div
        className={classNames(
          "flex max-w-[100dvw] grow flex-col gap-2  transition-all max-xl:p-4 duration-300",
          {
            "xl:max-w-[calc(100vw-5rem)]": isSidebarCollapsed,
            "xl:max-w-[calc(100vw-16rem)]": !isSidebarCollapsed,
            "xl:grid xl:px-4 xl:pt-[2dvh]": true,
            " lg:pt-[2dvh]": true,
          },
        )}
      >
        <Navbar />
        <div className="flex lg:h-[89dvh] h-[80dvh] max-h-full flex-col overflow-y-auto">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Template;
